import { Suspense, type ReactNode } from 'react';

import { lazyRoute } from 'src/routes/lazy-route';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import { CheckoutProvider } from 'src/sections/customer/checkout/context';
import { isRoleAdmin } from 'src/utils/check-user-is-admin';

import AdminOrCoffeeGuard from 'src/auth/guard/admin-coffee-guard';
import { paths } from '../paths';

// ----------------------------------------------------------------------
const CoffeeDashboardPage = lazyRoute(() => import('src/pages/coffee/dashboard'));
// ----------------------------------------------------------------------
// NAT-2788 — the coffee role sees this one page; admins see it too. Admins get the checkout
// provider their dashboard header's CartPopover reads, as on the admin routes. The coffee role
// gets none (no customer provider, no cart fetch): nothing on the page is client-scoped. Agent,
// customer and auditor only ever see the 403 here, so they get none either; for a customer it
// would scope the cart to the wrong venue, as /coffee has no ActingClientProvider. It is decided
// at render, so one route tree serves every role.
function CartForAdmin({ children }: { children: ReactNode }) {
  return isRoleAdmin() ? <CheckoutProvider>{children}</CheckoutProvider> : <>{children}</>;
}

export const coffeeRoutes = [
  {
    element: (
      <AuthGuard>
        <CartForAdmin>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </CartForAdmin>
      </AuthGuard>
    ),
    children: [
      {
        path: paths.coffee.dashboard,
        element: (
          <AdminOrCoffeeGuard>
            <CoffeeDashboardPage />
          </AdminOrCoffeeGuard>
        ),
      },
    ],
  },
];
